import { type DefaultProps, ModalPrimitive } from "../primitives/ModalPrimitive";

export const Default = (props: DefaultProps) => {
	return <ModalPrimitive {...props} sx={[props.sx]} />;
};
